import api from "./api";

export interface SaveReportCommand {
  id?: string;
  name: string;
  fields: string[];
  filters: {
    text: Record<string, string>;
    dates: Record<string, { from: string; to: string }>;
  };
}
export interface GetReport {
  pageNumber?: number;
  pageSize?: number;
};

export const getReports = async (filter?: GetReport) => {
  try {
    const response = await api.get(`/api/report`, {params: filter});
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getReportById = async (id: string) => {
  try {
    const response = await api.get(`/api/report/${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const saveReport = async (report: SaveReportCommand) => {
  try {
    const response = await api.post(`/api/report`, report);
    return response;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const updateReport = async (report: SaveReportCommand) => {
  try {
    const response = await api.put(`/api/report/${report.id}`, report);
    return response;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const deleteReport = async (id: string) => {
  try {
    const response = await api.delete(`/api/report/${id}`);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};
